import { render, staticRenderFns } from "./ChallengeReports.vue?vue&type=template&id=4a1d452a&scoped=true&lang=pug&"
import script from "./ChallengeReports.vue?vue&type=script&lang=js&"
export * from "./ChallengeReports.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeReports.vue?vue&type=style&index=0&id=4a1d452a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1d452a",
  null
  
)

export default component.exports